<template>
  <div class="df both-side">
    <a-space>
      <a-input
        v-model:value="requestPayload.endDate"
        placeholder="结束时间"
      ></a-input>
      <a-input
        v-model:value="requestPayload.produceDate"
        placeholder="生产日期"
      ></a-input>
      <a-input
        v-model:value="requestPayload.produceOrTpc"
        placeholder="生产模块or试产中心"
      ></a-input>
      <a-input
        v-model:value="requestPayload.productName"
        placeholder="产品名称"
      ></a-input>
      <a-input
        v-model:value="requestPayload.startDate"
        placeholder="开始时间"
      ></a-input>
    </a-space>

    <a-space>
      <a-button size="small" @click="handleInsertRequisition"> 添加 </a-button>
    </a-space>
  </div>
  <a-table
    :data-source="table.data"
    bordered
    :pagination="false"
    :columns="columns"
    :scroll="{ x: 'calc(100vw - 180px)', y: 'calc(100vh - 300px)' }"
    rowKey="id"
  >
    <template #action="{ record }">
      <a-button size="small">编辑</a-button>
    </template>
  </a-table>

  <requisition-form ref="requisitionFormRef"></requisition-form>
</template> 
 
    <script>
import { defineComponent, nextTick, ref, watch } from "vue";
import { Toast } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import { getMaterialRequisitionList } from "@/request/view/productionInstruction";

import requisitionForm from "@/views/productionInstruction/materialRequisition/form.vue";

export default defineComponent({
  components: {
    requisitionForm,
  },
  setup(props, context) {
    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    requestConfig.pull_fn = getMaterialRequisitionList;

    initPayload({
      endDate: null,
      produceDate: null,
      produceOrTpc: null,
      productName: null,
      startDate: null,
    });
    const columns = [
      {
        title: "用途",
        dataIndex: "applications",
        align: "center",
        width: "50px",
      },
      {
        title: "批准日期",
        dataIndex: "approveDate",
        align: "center",
        width: "100px",
      },
      {
        title: "批准人",
        dataIndex: "approver",
        align: "center",
        width: "75px",
      },
      {
        title: "生产批号",
        dataIndex: "batchNumber",
        align: "center",
        width: "100px",
      },
      { title: "核对人", dataIndex: "checked", align: "center", width: "75px" },
      {
        title: "核对时间",
        dataIndex: "checkedDate",
        align: "center",
        width: "100px",
      },
      { title: "版本", dataIndex: "edition", align: "center", width: "50px" },
      {
        title: "完成时间",
        dataIndex: "finishDate",
        align: "center",
        width: "100px",
      },
      {
        title: "表单编号",
        dataIndex: "formNumber",
        align: "center",
        width: "100px",
      },
      {
        title: "发料人",
        dataIndex: "goodsIssue",
        align: "center",
        width: "75px",
      },
      {
        title: "发料时间",
        dataIndex: "goodsIssueDate",
        align: "center",
        width: "100px",
      },
      { title: "", dataIndex: "id", align: "center", width: null },
      {
        title: "型号规格",
        dataIndex: "modelSpecifications",
        align: "center",
        width: "100px",
      },
      { title: "数量", dataIndex: "number", align: "center", width: "50px" },
      {
        title: "领料时间",
        dataIndex: "pickDate",
        align: "center",
        width: "100px",
      },
      { title: "领料人", dataIndex: "picker", align: "center", width: "75px" },
      { title: "", dataIndex: "pqcList", align: "center", width: null },
      {
        title: "生产日期",
        dataIndex: "produceDate",
        align: "center",
        width: "100px",
      },
      {
        title: "产品名称",
        dataIndex: "productName",
        align: "center",
        width: "100px",
      },
      {
        title: "",
        dataIndex: "productNumberList",
        align: "center",
        width: null,
      },
      {
        title: "审核日期",
        dataIndex: "reviewDate",
        align: "center",
        width: "100px",
      },
      {
        title: "审核人",
        dataIndex: "reviewer",
        align: "center",
        width: "75px",
      },
      { title: "单位", dataIndex: "unit", align: "center", width: "50px" },
      {
        title: "编制日期",
        dataIndex: "writeDate",
        align: "center",
        width: "100px",
      },
      { title: "编制人", dataIndex: "writer", align: "center", width: "75px" },
      {
        title: "操作",
        fixed: "right",
        slots: {
          customRender: "action",
        },
      },
    ];

    const requisitionFormRef = ref();

    const handleInsertRequisition = () => {
      requisitionFormRef.value.showModal("insert", {});
    };

    const getData = () => {
      getListData({ unPagingRequest: true });
    };

    const init = () => {
      getData();
    };

    init();

    return {
      table,
      columns,
      requestPayload,
      requisitionFormRef,
      handleInsertRequisition,
    };
  },
});
</script>
    